import React from 'react';
import styled from 'styled-components';
import { Title as TitleText } from '../../Text';
import TimelineCard from './TimelineCard';
import { Card } from '@tremor/react';

const Title = styled(TitleText)`
  text-align: left;
  font: normal normal 600 16px/25px Poppins;
  letter-spacing: 0px;
  color: #111723;
  opacity: 1;
`;

type TimelineProps = {
  events: {
    id: string;
    message: string;
    type: string;
    createdAt: string;
  }[];
};

const Timeline = (props: TimelineProps) => {
  return (
    <Card className="flex flex-col h-full">
      <div className="flex flex-row justify-between mb-1">
        <Title>Activity Overview</Title>
      </div>
      <div className="flex flex-col justify-between gap-2 overflow-scroll lg:max-h-[26rem]">
        {props.events.map((e) => (
          <TimelineCard key={e.id} {...e} />
        ))}
      </div>
    </Card>
  );
};

export default Timeline;
